import { VelocityTransactionQueueItem } from '@/api/audit/velocity-feed-audit';
import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns/format';
import { ArrowUpDown } from 'lucide-react';

const displayValue = (value: string | number | null | undefined) =>
	value ?? '---';

export const transactionQueueColumns: ColumnDef<VelocityTransactionQueueItem>[] =
	[
		{
			accessorKey: 'level1Org',
			header: ({ column }) => (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Level1Org
					<ArrowUpDown />
				</Button>
			),
			cell: ({ row }) => <div>{displayValue(row.original.level1Org)}</div>,
		},
		{
			accessorKey: 'description',
			header: ({ column }) => (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Description
					<ArrowUpDown />
				</Button>
			),
			cell: ({ row }) => <div>{displayValue(row.original.description)}</div>,
		},
		{
			accessorKey: 'policyId',
			header: ({ column }) => (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					PolicyID
					<ArrowUpDown />
				</Button>
			),
			cell: ({ row }) => <div>{displayValue(row.original.policyId)}</div>,
		},
		{
			accessorKey: 'policyNumber',
			header: ({ column }) => (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Policy Number
					<ArrowUpDown />
				</Button>
			),
			cell: ({ row }) => <div>{displayValue(row.original.policyNumber)}</div>,
		},
		{
			accessorKey: 'effectiveDate',
			header: ({ column }) => (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Effective Date
					<ArrowUpDown />
				</Button>
			),
			cell: ({ row }) => {
				const date = row.original.effectiveDate
					? format(new Date(row.original.effectiveDate), 'P')
					: '---';

				return <div>{date}</div>;
			},
		},
		{
			accessorKey: 'providerNumber',
			header: ({ column }) => (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Provider Number
					<ArrowUpDown />
				</Button>
			),
			cell: ({ row }) => <div>{displayValue(row.original.providerNumber)}</div>,
		},
		{
			accessorKey: 'providerName',
			header: ({ column }) => (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Provider Name
					<ArrowUpDown />
				</Button>
			),
			cell: ({ row }) => <div>{displayValue(row.original.providerName)}</div>,
		},
		{
			accessorKey: 'producerNumber',
			header: ({ column }) => (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Producer Number
					<ArrowUpDown />
				</Button>
			),
			cell: ({ row }) => <div>{displayValue(row.original.producerNumber)}</div>,
		},
		{
			accessorKey: 'producerName',
			header: ({ column }) => (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Producer Name
					<ArrowUpDown />
				</Button>
			),
			cell: ({ row }) => <div>{displayValue(row.original.producerName)}</div>,
		},
	];
